module.exports = __webpack_public_path__ + "static/media/dark_matin_logo.ae2884e8.png";